module.exports = __webpack_public_path__ + "static/media/program info icon (active).96ce6d0d.svg";